<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position:relative;">
      <span class="main-title">SUMMARY | &nbsp;</span>
      <span class="submain-title">Detail Customer report</span>
    </div>
    <download-excel
      :data="export_order_customer_report_list"
      :fields="{
        No: 'no',
        'Order code': 'order_code',
        'Order ref.': 'order_base_code',
        'Store name': 'order_store',
        'Order price': 'order_price',
        rider: 'order_rider_full_name',
      }"
      :name="
        $route.params.customername +
          '_' +
          $route.params.orderstart +
          '_to_' +
          $route.params.orderend +
          '.xls'
      "
      style="position:absolute;top:60px;right:80px;"
    >
      <v-btn icon> <v-icon large color="black">print</v-icon>.xls </v-btn>
    </download-excel>
    <download-excel
      type="csv"
      :data="export_order_customer_report_list"
      :fields="{
        No: 'no',
        'Order code': 'order_code',
        'Order ref.': 'order_base_code',
        'Store name': 'order_store',
        'Order price': 'order_price',
        rider: 'order_rider_full_name',
      }"
      :name="
        $route.params.customername +
          '_' +
          $route.params.orderstart +
          '_to_' +
          $route.params.orderend +
          '.csv'
      "
      style="position:absolute;top:60px;right:190px;"
    >
      <v-btn icon> <v-icon large color="black">print</v-icon>.csv </v-btn>
    </download-excel>
    <v-card dark style="border-radius:10px;">
      <v-layout row justify-space-between class="pa-3">
        <v-flex xs1>
          <div
            class="pt-2 text-xs-center search-btn"
            @click="
              $router.push({
                path:
                  '/weserve_admin_login/control/' +
                  $store.state.backOffice.province +
                  '/report/customer_report',
              })
            "
          >
            <v-icon large color="black">arrow_back</v-icon>
          </div>
        </v-flex>
      </v-layout>
    </v-card>

    <v-data-table
      :loading="isloading"
      :headers="headers"
      :items="order_customer_report_list"
      class="elevation-1 mt-4"
      style="background-color:white;padding:10px; border-radius:10px;"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color:black;"
        >{{ props.header.text }}</template
      >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.no }}</td>
        <td>{{ props.item.order_code }}</td>
        <td>{{ props.item.order_base_code }}</td>
        <td>{{ props.item.order_store_temp }}</td>
        <td class="text-xs-right">{{ props.item.order_price }}</td>
        <td>{{ props.item.order_rider_full_name }}</td>
      </template>
      <template slot="no-data">
        <div
          class="text-xs-center"
          v-if="order_customer_report_list.length == 0 && isloading == false"
        >
          No data available
        </div>
        <div v-else class="text-xs-center">
          <h3>Loading data ...</h3>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isloading: false,
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "num",
        },
        { text: "Order code", value: "order_code", sortable: false },
        { text: "Order ref.", value: "order_code", sortable: false },
        {
          text: "Store name",
          value: "store_name",
          sortable: false,
        },
        {
          text: "Order price",
          value: "order_price",
          align: "center",
          sortable: false,
        },
        {
          text: "rider",
          value: "rider",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  destroyed() {
    if (this.$route.name != "CustomerReport") {
      this.$store.commit("fetchCustomerReport/resetState");
    }
  },
  computed: {
    ...mapState({
      search_config: (state) => state.fetchCustomerReport.clone_config_path,
      order_customer_report_list: (state) =>
        state.fetchCustomerReport.order_customer_report_list,
      export_order_customer_report_list: (state) =>
        state.fetchCustomerReport.export_order_customer_report_list,
    }),
  },
  methods: {
    async fetchData() {
      let config = {
        customer_id: this.$route.params.customerid,
        order_start: this.$route.params.orderstart,
        order_end: this.$route.params.orderend,
        district_id: [0],
      };
      this.isloading = true;
      try {
        config.district_id = JSON.parse(this.$route.params.districtid);
      } catch {}

      this.$store.commit("fetchCustomerReport/getOrderCustomerList", []);
      if (config.district_id[0] == 0) {
        await this.$store.dispatch(
          "fetchCustomerReport/getOrderCustomerList",
          config
        );
      } else {
        await this.$store.dispatch(
          "fetchCustomerReport/fetchOrderCustomerListtByDistrict",
          config
        );
      }

      this.isloading = false;
    },
  },
  async created() {
    await this.fetchData();
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Customer report",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/customer_report",
      },
      {
        text: "Detail",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/detail_customer_report",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
}
</style>
